import ReactLoading from 'react-loading';

export default function CargandoSpin() {

/* types para el ReactLoading
balls
bars
bubbles
cubes
cylon
spin
spinningBubbles
spokes
*/

const DivLoadingReact = () => (
    <ReactLoading type={'spin'} color={'#0d6efd'} height={467} width={175} />
);
 return(
    <div className="divLoading">
        <div className="divLoadingImg"><DivLoadingReact /></div>
    </div>
  );
} 